import { ADD_ROTATION_POSITION, ADD_ROTATION_POSITION_ERROR, ADD_ROTATION_POSITION_SUCCESS } from './actionTypes';

export const addRotationPosition = (ws_pos, rotation_point, token, history) => {
  return {
    type: ADD_ROTATION_POSITION,
    payload: { ws_pos, rotation_point, token, history },
  };
};

export const addRotationPositionSuccess = (message, addedRotation) => {
  return {
    type: ADD_ROTATION_POSITION_SUCCESS,
    payload: { message, addedRotation },
  };
};

export const addRotationPositionError = (message) => {
  return {
    type: ADD_ROTATION_POSITION_ERROR,
    payload: message,
  };
};
